import { AsyncComponent } from '@twigeducation/async-component';
import { WithAuthentication } from '@twigeducation/oidc-client-react';
import React from 'react';
import { Route } from 'react-router-dom';
import { FeatureFlag } from '@twigeducation/unleash-client-react';
import { SpeechStream } from '@twigeducation/speechstream';
import Layout from '../../layout';
import withProductSubscriptions from '../../components/withProductSubscriptions';
import digitalGlossaryUrl from './urls';
import ReadSpeaker from '../../components/ReadSpeaker';

import NotFound from '../NotFound';
import AsyncComponentError from '../../components/AsyncComponentError';

const DigitalGlossary = withProductSubscriptions(props => (
    <FeatureFlag
        key="digital-glossary"
        flagKey="digital-glossary"
        renderFeatureCallback={() => (
            <AsyncComponent
                appName="ms-digital-glossary-mfe"
                componentName="DigitalGlossary"
                errorComponent={AsyncComponentError}
                {...props}
            />
        )}
        renderDefaultCallback={() => <NotFound />}
    />
));

const SpeechStreamWithStartingPoints = props => (
    <SpeechStream {...props} startingPoints={['termModalBody']} autoPlay showFixedToolbar fillColor="#0D729A" />
);

const allowedRoles = ['TEACHER', 'STUDENT', 'SCHOOL_ADMIN', 'DISTRICT_OWNER', 'TWIGADMIN'];

const routes = [
    <Route path={`${digitalGlossaryUrl}*`} key="digital-glossary">
        <WithAuthentication roles={allowedRoles}>
            <DigitalGlossary Layout={Layout} ReadSpeaker={ReadSpeaker} SpeechStream={SpeechStreamWithStartingPoints} />
        </WithAuthentication>
    </Route>,
];
export default routes;
